import * as React from 'react';
import {
    Datagrid,
    Edit,
    NumberInput,
    BooleanInput,
    ReferenceManyField,
    TextInput,
    //TabbedForm,
    FormTab,
    SaveButton,
    Toolbar,
    FileInput,
    FileField,
    ReferenceField,
    FunctionField,
    DateField,
    DateInput,
    Labeled,
    useTranslate,
    BooleanField,
    useEditContext,
    TextField,
    useRecordContext,
    useGetIdentity,
    useResourceContext,
} from 'react-admin';
import { TabbedForm, useCanAccess } from '@react-admin/ra-rbac';
import {
    required,
    minValue,
    maxValue,
    minLength,
    maxLength,
    number,
    email,
    regex,
    choices,
} from 'react-admin';
import { Grid, Box, Typography, Stack, Link } from '@mui/material';

import {
    CustomSelectInput,
    CustomSelectArrayInput,
    CustomCheckboxGroupInput,
    CustomRadioButtonGroupInput,
    CustomJSONPretty,
    CustomTextField,
    CustomBulkDeleteButton,
    CustomBulkAddButton,
    CustomProductList,
    CustomNumberInput,
    CustomLogEventList,
    CustomUserLicenseByUserList,
    CustomUserSchoolList,
    CustomServicesField,
    CustomUserGroupList,
} from '../../controls';

import {
    LibraryBooks,
    Article,
    Podcasts,
    Attachment,
    DataObject,
    TransferWithinAStation,
    History,
    Computer,
} from '@mui/icons-material';

import { EditableDatagrid, RowForm } from '@react-admin/ra-editable-datagrid';
import CustomStatistics from '../../controls/CustomStatistics';
import StatsWithIcon from '../../../components/statistics/controls/StatsWithIcon';
import SourceNameField from '../SourceNameField';
import Merge from '../controls/Merge';
import SessionBadge from '../controls/SessionBadge';
import StaleBadge from '../controls/StaleBadge';
import ConditionalLoginField from '../ConditionalLoginField';
import ExtraMaterials from '../controls/Extramaterials';

const EditToolbar = () => {
    const resource = useResourceContext();
    const { canAccess } = useCanAccess({ action: 'write', resource });
    return (
        <Toolbar>
            {canAccess ? (
                <SaveButton />
            ) : (
                <Typography variant="body2" color="warning.main">
                    Sinulla ei ole muokkausoikeutta.
                </Typography>
            )}
        </Toolbar>
    );
};

const ApplicationForm = () => {
    const useEdit = useEditContext();
    //console.log('record', record);
    return (
        <RowForm defaultValues={{ user_guid: useEdit.record.guid }}>
            <CustomSelectInput
                resource="userapplication"
                source="application_guid"
                url="extralist/userapplication/applications"
                label=""
                validate={[required()]}
            />
            <BooleanInput
                resource="userapplication"
                source="isadmin"
                label=""
            />
            <CustomSelectInput
                resource="userapplication"
                source="public.userrights"
                url="extralist/userapplication/userrights"
                label=""
                showIfControl="application_guid"
                showIfValue="13b312b5-367c-4c74-bb77-bdb34df4e721"
                validate={[required()]}
            />
            <CustomSelectInput
                resource="userapplication"
                source="status"
                url="extralist/userapplication/statuses"
                label=""
                validate={[required()]}
            />
        </RowForm>
    );
};

const SchoolFormEdit = () => {
    const useEdit = useEditContext();
    //console.log('record', record);
    return (
        <RowForm
            defaultValues={{
                user_guid: useEdit.record.guid,
                group_guid: useEdit.record.group_guid,
            }}
        >
            {/* <CustomAutocompleteInput resource="usergroup" source="group_guid" url="extralist/schools" /> */}
            <TextField resource="usergroup" source="group.name" label="" />
            <DateField resource="usergroup" source="author.created" label="" />
            <CustomSelectInput
                resource="usergroup"
                source="status"
                label=""
                url="extralist/student/statuses"
                validate={[required()]}
            />
        </RowForm>
    );
};

const ClassList = ({ canWrite }: { canWrite?: boolean | null }) => {
    const useRecord = useRecordContext();
    //console.log('useEditSchool', useRecord);
    return (
        <Edit
            resource="group"
            id={useRecord.group_guid}
            title=" "
            className="cgl-dg-edit"
        >
            <Grid container width={{ xs: '100%' }} spacing={2}>
                <Grid size={12}>
                    <CustomUserGroupList
                        disableSyncWithLocation
                        storeKey="customUserGroupList"
                        resource="usergroup"
                        params={{ user_guid: useRecord.user_guid }}
                        filter={{ type: 4 }}
                        customFilters={['parent_guid', 'user_guid']}
                        showExtra={['onlyactive']} //['onlyactive']
                        hideFields={[]} //['join', 'status', 'group_status', 'name', 'archived']
                        bulkActionButtons={false}
                        actions={canWrite ? undefined : false}
                    >
                        <span />
                    </CustomUserGroupList>
                </Grid>
            </Grid>
        </Edit>
    );
};

const PupilEdit = () => {
    const translate = useTranslate();
    const resource = useResourceContext();
    const { canAccess: canWrite } = useCanAccess({ action: 'write', resource });

    return (
        <Edit
            redirect={false}
            mutationMode="optimistic"
            queryOptions={{ refetchOnMount: 'always' }}
        >
            <TabbedForm toolbar={<EditToolbar />}>
                <FormTab
                    label="resources.pupil.tabs.profile"
                    icon={<Article />}
                >
                    <Grid
                        container
                        alignItems="flex-end"
                        width={{ xs: '100%' }}
                        spacing={2}
                    >
                        <Grid size={{ xs: 12, md: 8 }}>
                            <TextInput
                                resource="pupil"
                                source="public.firstname"
                                validate={[required()]}
                                fullWidth
                            />
                            <TextInput
                                resource="pupil"
                                source="public.middlename"
                                fullWidth
                            />
                            <TextInput
                                resource="pupil"
                                source="public.lastname"
                                validate={[required()]}
                                fullWidth
                            />
                            <TextInput
                                resource="pupil"
                                source="public.code"
                                validate={[required()]}
                                fullWidth
                            />
                            <CustomSelectInput
                                resource="pupil"
                                source="status"
                                url="extralist/pupil/statuses"
                                parse={v => parseInt(v)}
                                fullWidth
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                            <BooleanInput
                                resource="pupil"
                                source="public.login_not_allowed"
                            />
                            <BooleanInput
                                resource="pupil"
                                source="public.profile_locked"
                            />
                            <Box
                                display={{ xs: 'block', sm: 'flex' }}
                                sx={{ marginBottom: 2 }}
                            >
                                <Labeled>
                                    <SessionBadge
                                        source="last_login"
                                        options={{
                                            showTTL: true,
                                            showSessionDelete: true,
                                        }}
                                    >
                                        <ConditionalLoginField
                                            resource="pupil"
                                            showTime
                                            locales="fi-FI"
                                        />
                                    </SessionBadge>
                                </Labeled>{' '}
                            </Box>

                            <Box
                                display={{ xs: 'block', sm: 'flex' }}
                                sx={{ marginBottom: 2 }}
                            >
                                <Labeled label="resources.user.stale.title">
                                    <StaleBadge
                                        options={{
                                            showDetails: true,
                                            showToggle: true,
                                        }}
                                    >
                                        <span />
                                    </StaleBadge>
                                </Labeled>
                            </Box>

                            <Box
                                display={{ xs: 'block', sm: 'flex' }}
                                sx={{ marginBottom: 2 }}
                            >
                                <Labeled label="resources.pupil.fields.services">
                                    <SourceNameField
                                        showRemove={!!canWrite}
                                        showDebug={!!canWrite}
                                    />
                                </Labeled>
                            </Box>

                            <Stack direction="row" spacing={4}>
                                <Box>
                                    <Labeled label="resources.pupil.fields.author.creator">
                                        <>
                                            <ReferenceField
                                                reference="user"
                                                source="author.creator"
                                            >
                                                <FunctionField
                                                    render={record =>
                                                        `${record.public.firstname} ${record.public.lastname}`
                                                    }
                                                />
                                            </ReferenceField>
                                            <DateField
                                                resource="pupil"
                                                source="registered"
                                                showTime
                                                locales={'fi-FI'}
                                            />
                                        </>
                                    </Labeled>
                                </Box>
                                <Box>
                                    <Labeled label="resources.pupil.fields.author.modifier">
                                        <>
                                            <ReferenceField
                                                reference="user"
                                                source="author.modifier"
                                            >
                                                <FunctionField
                                                    render={record =>
                                                        `${record.public.firstname} ${record.public.lastname}`
                                                    }
                                                />
                                            </ReferenceField>
                                            <DateField
                                                resource="pupil"
                                                source="author.modified"
                                                showTime
                                                locales={'fi-FI'}
                                            />
                                        </>
                                    </Labeled>
                                </Box>
                            </Stack>
                        </Grid>
                    </Grid>
                </FormTab>
                <TabbedForm.Tab
                    label="resources.user.tabs.application"
                    icon={<Computer />}
                    path="palvelut"
                    name="palvelut"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={12}>
                            <ReferenceManyField
                                reference="userapplication"
                                target="user_guid"
                            >
                                <EditableDatagrid
                                    bulkActionButtons={
                                        canWrite ? undefined : false
                                    }
                                    createForm={
                                        canWrite ? (
                                            <ApplicationForm />
                                        ) : undefined
                                    }
                                    editForm={<ApplicationForm />}
                                    noDelete={!canWrite}
                                    actions={canWrite ? undefined : false}
                                >
                                    <CustomSelectInput
                                        resource="userapplication"
                                        source="application_guid"
                                        label={translate(
                                            'resources.user.fields.application.name'
                                        )}
                                        url="extralist/userapplication/applications"
                                        showAsText={true}
                                    />
                                    <BooleanField
                                        resource="userapplication"
                                        source="isadmin"
                                        label={translate(
                                            'resources.user.fields.application.isadmin'
                                        )}
                                    />
                                    <CustomSelectInput
                                        resource="userapplication"
                                        source="public.userrights"
                                        label={translate(
                                            'resources.user.fields.application.role'
                                        )}
                                        url="extralist/userapplication/userrights"
                                        showAsText={true}
                                    />
                                    <CustomSelectInput
                                        resource="userapplication"
                                        source="status"
                                        label={translate(
                                            'resources.user.fields.application.status'
                                        )}
                                        url="extralist/userapplication/statuses"
                                        showAsText={true}
                                    />
                                </EditableDatagrid>
                            </ReferenceManyField>
                        </Grid>
                    </Grid>
                </TabbedForm.Tab>
                <FormTab
                    label="resources.pupil.tabs.schools_and_groups"
                    icon={<LibraryBooks />}
                    path="koulut_ja_ryhmat"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={12}>
                            <ReferenceManyField
                                reference="usergroup"
                                target="user_guid"
                                filter={{ type: 2 }}
                            >
                                <EditableDatagrid
                                    bulkActionButtons={false}
                                    editForm={<SchoolFormEdit />}
                                    expand={<ClassList canWrite={!!canWrite} />}
                                    expandSingle={true}
                                    rowClick="expand"
                                    noDelete
                                    actions={canWrite ? undefined : false}
                                >
                                    {/* <CustomSelectInput resource="usergroup" source="group_guid" label={translate('resources.user.fields.group.name')} url="extralist/schools" filter="group_guid" showAsText={true} /> */}
                                    <FunctionField
                                        resource="usergroup"
                                        source="group.name"
                                        label={translate(
                                            'resources.user.fields.group.name'
                                        )}
                                        render={record => {
                                            return (
                                                <Link
                                                    href={`#/school/${record.group_guid}`}
                                                    sx={{ color: 'inherit' }}
                                                    onClick={e =>
                                                        e.stopPropagation()
                                                    }
                                                    underline="hover"
                                                >
                                                    {record.group.name}
                                                </Link>
                                            );
                                        }}
                                    />
                                    <DateField
                                        resource="usergroup"
                                        source="author.created"
                                        locales={'fi-FI'}
                                        showTime
                                        label={translate(
                                            'resources.student.fields.school.registered'
                                        )}
                                    />
                                    <CustomSelectInput
                                        resource="usergroup"
                                        source="status"
                                        label={translate(
                                            'resources.user.fields.group.status'
                                        )}
                                        url="extralist/pupil/statuses"
                                        showAsText={true}
                                    />

                                    {/* <CustomSelectInput resource="usergroup" source="public.userrights" label={translate('resources.user.fields.group.role')} url="extralist/userapplication/userrights" showAsText={true} />
                                     */}
                                </EditableDatagrid>
                            </ReferenceManyField>
                        </Grid>
                    </Grid>
                </FormTab>
                <FormTab
                    label="resources.pupil.tabs.materials"
                    icon={<LibraryBooks />}
                    path="kaytossa"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={12}>
                            <CustomUserLicenseByUserList
                                resource="userlicense"
                                disableSyncWithLocation
                                customFilters={['user_guid']}
                                showExtra={['seasonFilter']}
                                hideFields={[]}
                                sort={{ field: 'product.name', order: 'ASC' }}
                                bulkActionButtons={
                                    canWrite ? (
                                        <CustomBulkDeleteButton />
                                    ) : (
                                        false
                                    )
                                }
                            >
                                <span />
                            </CustomUserLicenseByUserList>
                            <ExtraMaterials />
                        </Grid>
                    </Grid>
                </FormTab>
                <FormTab
                    label="resources.pupil.tabs.merge"
                    icon={<LibraryBooks />}
                    path="yhdistaminen"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={12}>
                            {canWrite ? (
                                <Merge />
                            ) : (
                                <Typography
                                    variant="body2"
                                    color="warning.main"
                                >
                                    Sinulla ei ole oikeutta yhdistää käyttäjiä.
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </FormTab>
                <FormTab
                    label="resources.pupil.tabs.logs"
                    icon={<History />}
                    path="logit"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={12}>
                            <CustomStatistics
                                statisticKey="userEvents"
                                handler={StatsWithIcon}
                                mode="List"
                                from="30d"
                                limit={30}
                                exclude_search={[
                                    'updateAspaProfile',
                                    'FORCE_LOGOUT',
                                ]}
                                include_search={[]}
                                pagination={true}
                                showFilter={true}
                                include_source_fields={[
                                    'infra2.request_detail',
                                ]}
                            />
                        </Grid>
                    </Grid>
                </FormTab>
            </TabbedForm>
        </Edit>
    );
};

const redirect: any = () => {
    return window.location.hash.replace('#', '');
};

export default PupilEdit;
